/*
https://splidejs.com/guides/getting-started/
*/

// import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const slider = document.querySelector('.provider-doctors-slider .splide');

if( slider ) {
    var splide = new Splide( '.provider-doctors-slider .splide' , {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: true,
        pagination: false,
        perPage: 3,
        perMove: 1,
        arrowPath: 'M15.3926 28.1825L1.80101 14.7222L15.3926 1.26186',
        gap: '16px',
        breakpoints: {
            960: {
                perPage: 1,
                padding: {
                    right: '10%'
                },
            },
        }
    });
    splide.mount();
}